/**
 * The files the MP3 encoder (src/media/mp3-encode.ts) loads at run time, and where the site serves
 * them: LAME as WebAssembly, and the licence texts that travel with it.
 *
 * ONE LIST, TWO READERS, like the OCR assets (src/ocr/assets.ts): `build/build.mjs` copies each
 * `from` to `web/static/vendor/<to>`, and the page builds the encoder's URL from the same `to`.
 *
 * NOT LOADED ON A PAGE VIEW. The page bundle holds only the URL string; the first conversion on
 * /mp4-to-mp3 is what fetches the 133 KB file (about 60 KB gzipped).
 *
 * VERSIONED BY DIRECTORY, so a new LAME build can never be served under an old URL from the
 * edge cache. The wrapper's JavaScript checks that the WebAssembly is the build it was written for
 * (`wasm-media-encoders-0.7.0`) and refuses any other, so the two move together in package.json.
 */

import { VENDOR_URL, type VendorFile } from '../ocr/assets.ts';

export const LAME_VERSION = '3.100';
const DIR = `mp3/lame-${LAME_VERSION}`;

export const MP3_VENDOR_FILES: readonly VendorFile[] = [
  {
    from: 'node_modules/wasm-media-encoders/wasm/mp3.wasm',
    to: `${DIR}/mp3.wasm`,
    // Unmodified: the file wasm-media-encoders 0.7.0 publishes (src/vendor/lame-3.100/NOTICE.md).
    sha256: '85e81719250b9a667b1258143f689dda70e3e57a7e7c29ab0b4cef65c8f6eb9a',
  },
  { from: 'src/vendor/lame-3.100/COPYING', to: `${DIR}/COPYING.txt` },
  { from: 'src/vendor/lame-3.100/NOTICE.md', to: `${DIR}/NOTICE.md` },
  {
    from: 'node_modules/wasm-media-encoders/LICENSE',
    to: `${DIR}/LICENSE-wasm-media-encoders.txt`,
  },
];

/** Where the worker fetches LAME from, cache-busted with the build id. */
export function mp3WasmUrl(buildId: string | null): string {
  const v = buildId ? `?v=${encodeURIComponent(buildId)}` : '';
  return `${VENDOR_URL}/${DIR}/mp3.wasm${v}`;
}
